import axios from "axios";
import Globais, { validateToken } from "../../components/Globais";

export async function atualizarUsuarioGlobais(usuarioId: number, formData: any) {

    const Token = validateToken();

    if(Token){
      //traz todos os representantes da cota validos e ainda a serem checados
        const URL = `${Globais.DOMINIOBACK}/usuario/${usuarioId}`;

        try {
          const response = await axios.put(URL, formData,{
            headers: { Authorization: Token.AuthStr },
          });
          if (response) {
            return true;
          }else{
            return false;
          }
        } catch (e) {
          console.log(e);
    
          return false;
        }

    }else{
        document.location.href = "/login";
        return false;
    }

}